module.exports = __webpack_public_path__ + "assets/img/ic-statistics.718af5cb.svg";